import React, { useState } from 'react'
import '../service/Services.css'
import { Link } from 'react-router-dom';
import StrippingTop from '../../components/serviceStripping/StrippingTop';
import Strippingbottom from '../../components/serviceStripping/Strippingbottom';
import ExclusiveContent from '../../components/servicesExclusiveContent/ExclusiveContent';

const Services = () => {
     const [activeTab, setActiveTab] = useState(0); // Tracks the active tab
    
  return (
    <div className='dashboard-content-box services-section p-0'>
        <div className='services-modal-tabs position-relative'>
            <div className="tabs-container">
                <div className="tabs-header d-flex flex-wrap align-items-center position-relative">
                    <div className='new-cat'>
                        <Link className="tab-button btn btn-border active-border  d-flex flex-wrap justify-content-center align-content-center" rel='stylesheet' >
                            <span className='icons-box'>
                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.3086 6.23975V15.4705" stroke="#FD59D9" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.69238 10.855H15.9232" stroke="#FD59D9" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.6932 0.85498H5.92398C3.37498 0.85498 1.30859 2.92137 1.30859 5.47037V16.2396C1.30859 18.7887 3.37498 20.855 5.92398 20.855H16.6932C19.2423 20.855 21.3086 18.7887 21.3086 16.2396V5.47037C21.3086 2.92137 19.2423 0.85498 16.6932 0.85498Z" stroke="#FD59D9" stroke-linecap="round" stroke-linejoin="round"/></svg>
                            </span>
                            <span className='text-box'>New Category</span>
                        </Link>
                    </div>
                    <button  className={`tab-button d-flex align-items-center ${activeTab === 0 ? "active" : ""}`} onClick={() =>  setActiveTab(0)}>
                        <span className='text-btn'>Exclusive Content</span>
                    </button>
                    <button   className={`tab-button  d-flex align-items-center ${activeTab === 1 ? "active" : ""}`} onClick={() =>  setActiveTab(1)}>
                        <span className='text-btn'>Stripping</span>
                    </button>
                    <button   className={`tab-button  d-flex align-items-center ${activeTab === 2 ? "active" : ""}`} onClick={() =>  setActiveTab(2)}>
                        <span className='text-btn'>Escorting</span>
                    </button>
                    <button   className={`tab-button  d-flex align-items-center ${activeTab === 3 ? "active" : ""}`} onClick={() =>  setActiveTab(3)}>
                        <span className='text-btn'>Companionship</span>
                    </button>
                    <button   className={`tab-button  d-flex align-items-center ${activeTab === 4 ? "active" : ""}`} onClick={() =>  setActiveTab(4)}>
                        <span className='text-btn'>VideoChat</span>
                    </button>
                </div>

                {/* Tab Content */}
                <div className="tabs-content">
                {activeTab === 0 && (
                    <div className="tab-panel">
                        <ExclusiveContent />
                    </div>
                )}
                {activeTab === 1 && (
                    <div className="tab-panel">
                        <StrippingTop />
                        <Strippingbottom />
                    </div>
                )}
                {activeTab === 2 && (
                    <div className="tab-panel">
                        {/* <SuggestedTabs /> */}
                        d
                    </div>
                )}
                {activeTab === 3 && (
                    <div className="tab-panel">
                        {/* <SuggestedTabs /> */}
                        e
                    </div>
                )}
                {activeTab === 4 && (
                    <div className="tab-panel">
                        {/* <SuggestedTabs /> */}
                        f
                    </div>
                )}
                </div>
            </div>
        </div>

      </div>
  )
}

export default Services
